<template>
  <div class="content bg8">
      <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
        <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
          <option value="/digital-marketing-internship">Digital Marketing</option>
          <option value="/social-media-marketing-internship">Social Media Marketing</option>
          <option value="/content-creation-internship">Content Creation and Copywriting</option>
          <option value="/website-design-internship">Website Design</option>
          <option value="/data-analytics-internship">Data Analytics and BI</option>
          <option value="/graphic-design-internship">Graphic Design</option>
        </select>
      </div>
      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>
      <div class="basehero">
        <h1>Data Analytics &amp; Business Intelligence Internship Program</h1>
        <h2 class="section">Turn Data Into Decisions</h2>

        <p>
          <strong>Foclarity’s Data Analytics &amp; BI Internship Program</strong> connects startups with data-savvy student interns who can transform raw numbers into clear, actionable insights. Interns work with real company data to analyze trends, build dashboards, and guide smarter decision-making. Startups benefit from sharper reporting and data-backed recommendations—without the cost of hiring a full team.
        </p>

        <h3>For Startups:</h3>
        <p>
          Make sense of your data, fast. Our interns bring analytical horsepower and modern tools to help you uncover patterns, track key metrics, and optimize your business.
        </p>
        <ul>
          <li>Data collection, cleaning, and organization</li>
          <li>Trend and performance analysis across marketing, sales, product, and more</li>
          <li>Interactive dashboards in tools like Looker Studio, Tableau, or Power BI</li>
          <li>Custom reports and visualizations that simplify the complex</li>
          <li>Data-backed insights and actionable business recommendations</li>
        </ul>
        <p>
          We match you with interns who understand your industry—and help guide the work with analytics professionals ensuring quality and clarity.
        </p>

        <h3>For Interns:</h3>
        <p>
          Dive into real-world data challenges with real impact. You'll work with startups to analyze performance, uncover insights, and communicate findings clearly—while building a portfolio that proves your value.
        </p>
        <ul>
          <li>Hands-on work in Excel, SQL, Python, and BI tools like Tableau or Looker</li>
          <li>Practice designing dashboards and presenting data visually</li>
          <li>Build reports that help founders understand KPIs and customer behavior</li>
          <li>Learn how data drives decisions in startups and product teams</li>
          <li>Feedback and mentorship from experienced data analysts</li>
        </ul>
        <p>
          You’ll leave with the skills, confidence, and portfolio to compete in today’s data-driven job market.
        </p>

        <h3>Ready to Dive into the Data?</h3>
        <p>
          If you're a founder who wants smarter insights—or a student ready to turn spreadsheets into strategy—this is your next step.
        </p>

        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">ApIntern Application</button>
          </a>
        </div>
      </div>
      <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#f7f2fa;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
        <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
          <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
          <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
          <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
          <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
          <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
        </ul>
        <div style="margin-top:18px;">
          <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataAnalyticsInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
